import * as React from 'react';
import { LayoutComponent } from '../LayoutComponent';
import { LayoutDefinition } from '../../../../infra/protected/Layout/LayoutDefinitions';
import { Flex, View } from '@adobe/react-spectrum';
import { ComponentFactory } from '../ComponentFactory';
import { FPAData } from '../../../../infra/protected/FPA/FPAData';
import { SystemAttributes } from '../../../../infra/protected/Layout/SystemAttributes';

export interface IHorizontalLayoutProps {
  children?: LayoutDefinition[];
  selectedItem?: FPAData;
  systemAttributes: SystemAttributes<FPAData>;
}

function HorizontalLayout({ children, selectedItem, systemAttributes }: IHorizontalLayoutProps) {
  if (!children || children.length === 0) return <>No children</>;

  const fallbackPercentWidth = 100 / children.length;
  return (
    <Flex direction={{ base: 'column', M: 'row' }} gap="size-100">
      {children.map((child, index) => {
        const configuredPercentWidth =
          child.layoutAttributes?.percentWidth ||
          child.componentAttributes?.percentWidth ||
          fallbackPercentWidth;

        return (
          <View
            key={index}
            width={{ base: '100%', M: `${configuredPercentWidth}%` }}
            flex={{ base: '0 0 auto', M: `0 1 ${configuredPercentWidth}%` }}
            UNSAFE_style={{ minWidth: 0 }}
          >
            <ComponentFactory
              selectedItem={selectedItem!}
              definition={child}
              systemAttributes={systemAttributes}
            />
          </View>
        );
      })}
    </Flex>
  );
}

export const HorizontalLayoutComponent = LayoutComponent(HorizontalLayout);
